<adapt-dialog [maxWidth]="1000">
    <h3 adapt-dialog-title>{{ data.title }}</h3>

    <ng-container adapt-dialog-content>
        @for (pair of keyValuePairs; track pair.key) {
            <div class="form-group row mb-2">
                <label class="col-3 align-self-center text-end">{{ pair.key }}</label>
                <div class="col-9 d-flex">
                    <dx-text-area class="flex-grow-1"
                                  [value]="pair.value"
                                  [readOnly]="true"
                                  [autoResizeEnabled]="true"
                                  [minHeight]="30"
                                  [maxHeight]="300"></dx-text-area>
                    <button type="button"
                            class="ms-2 btn btn-outline-primary"
                            adaptTooltip="Copy to clipboard"
                            adaptButtonIcon="fal fa-fw fa-copy"
                            (click)="copyValue(pair.value)"></button>
                </div>
            </div>
        }
    </ng-container>

    <button adapt-dialog-footer
            class="btn btn-secondary ms-auto"
            (click)="cancel()">Close</button>
</adapt-dialog>
